import SectionHead from "./SectionHead";
import Icon from "./Icon";

export default function Topics({ topics }) {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-3">
        <SectionHead eyebrow={topics.eyebrow} title={topics.title} sub={topics.subtitle} />
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-3">
          {topics.items.map((t, i) => (
            <div key={i} className="dc-card p-4">
              <div className="mb-3 text-violet-500">
                <Icon name={t.icon} size={26} />
              </div>
              <div className="font-bold text-gray-900 mb-2">{t.title}</div>
              <div className="text-gray-400 text-sm leading-relaxed">{t.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}